class SearchPlaceholderRotator extends HTMLElement {
  constructor() {
    super();
    this.span = this.querySelector('.header__search-bar-placeholder');
    this.phrases = (this.dataset.phrases || '').split('|').filter(Boolean);
    const field = this.closest('.field');
    this.input = field ? field.querySelector('input[type="search"]') : null;

    if (!this.span || !this.input || this.phrases.length < 2) return;

    this.index = 0;
    this.onFocus = () => this.stop();
    this.onBlur = () => {
      if (!this.input.value) this.start();
    };

    this.input.addEventListener('focus', this.onFocus);
    this.input.addEventListener('blur', this.onBlur);

    if (!this.input.value) this.start();
  }

  start() {
    if (this.timer) return;
    this.timer = setInterval(() => this.next(), 3000);
  }

  stop() {
    clearInterval(this.timer);
    this.timer = null;
  }

  next() {
    this.span.style.opacity = '0';
    setTimeout(() => {
      this.index = (this.index + 1) % this.phrases.length;
      this.span.textContent = this.phrases[this.index];
      this.span.style.opacity = '1';
    }, 400);
  }

  disconnectedCallback() {
    this.stop();
    if (this.input) {
      this.input.removeEventListener('focus', this.onFocus);
      this.input.removeEventListener('blur', this.onBlur);
    }
  }
}

customElements.define('search-placeholder-rotator', SearchPlaceholderRotator);
